export function SignInFieldsNormal({
  onEmailChange = (email: string) => {
    return;
  },
  onPasswordChange = (password: string) => {
    return;
  },
  onForgotPassword = () => {
    return;
  },
}) {
  return (
    <>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Email address
        </label>
        <div className="mt-1">
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-black dark:focus:border-white focus:outline-none focus:ring-black dark:focus:ring-white sm:text-sm"
            onChange={(event) => {
              onEmailChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Password
        </label>
        <div className="mt-1">
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-black dark:focus:border-white focus:outline-none focus:ring-black dark:focus:ring-white sm:text-sm"
            onChange={(event) => {
              onPasswordChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        {/* <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-[#E5FD6E] focus:ring-[#E5FD6E]"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                  Remember me
                </label>
              </div> */}

        <div className="text-sm ml-auto">
          <button
            type="button"
            className="font-medium text-black dark:text-white hover:text-slate-800 dark:hover:text-slate-200 bg-transparent outline-none border-none shadow-none"
            onClick={(event) => {
              event.preventDefault();
              onForgotPassword();
            }}
          >
            Forgot your password?
          </button>
        </div>
      </div>
    </>
  );
}

export function SignInFooter({ onJoin = () => {} }) {
  return (
    <div>
      <div className="flex flex-row justify-center items-center space-x-1">
        <span>Not a member?</span>
        <button
          className={[
            'font-bold',
            'bg-transparent outline-none border-none shadow-none',
            // loginStatus.isLogginIn ? 'pointer-events-none' : 'cursor-pointer',
          ].join(' ')}
          onClick={(event) => {
            event.preventDefault();
            onJoin();
          }}
        >
          <span className="h-6">Join waitlist</span>
        </button>
      </div>
    </div>
  );
}
